import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

import { isServer } from 'helpers/utilities'

const Portal: React.FC<PortalProps> = (props) => {
  const {
    portalId = 'portal-root',
    children,
  } = props

  const portalRef = useRef(document?.getElementById(portalId))

  useEffect(() => {
    if (!portalRef.current) {
      portalRef.current = document.createElement('div')
      portalRef.current.setAttribute('id', portalId)
      document.body.appendChild(portalRef.current)
    }
  }, [portalRef.current])

  if (isServer() || !portalRef.current) {
    return null
  }

  return createPortal(
    children,
    portalRef.current,
  )
}

interface PortalProps {
  portalId?: string
}

export default Portal
